import React, { useState } from "react";
import { Form, Row, Col, Container, Card, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { addExpense } from "../../store/slices/expense";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function AddExpense() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const expensestate = {
    title: "",
    category: "",
    amount: "",
    taxAmount: "",
    expenseDate: "",
    paymentMode: "",
    notes: "",
    status: "",
  };

  const [formData, setFormData] = useState(expensestate);

  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    let error = "";

    if (name === "title") {
      updatedValue = value.replace(/[^A-Za-z\s\-]/g, "");

      if (!updatedValue.trim()) {
        error = "Please enter title";
      } else if (updatedValue.length < 3) {
        error = "Minimum 3 characters required";
      } else if (updatedValue.length > 50) {
        error = "Maximum 50 characters only";
      }
    }

    if (name === "taxAmount") {
      updatedValue = value.replace(/\D/g, "");
      const numericAmount = Number(updatedValue);

      if (numericAmount < 0) {
        error = "Amount must be greater than 0";
      }
    }

    if (name === "amount") {
      updatedValue = value.replace(/\D/g, "");
      const numericAmount = Number(updatedValue);

      if (!updatedValue.trim()) {
        error = "Please enter amount";
      } else if (numericAmount <= 0) {
        error = "Amount must be greater than 0";
      }
    }

    if (name === "expenseDate") {
      const today = new Date().toISOString().split("T")[0];

      if (!updatedValue) {
        error = "Please select expense date";
      } else if (updatedValue > today) {
        error = "Future date not allowed";
      }
    }

    if (name === "category") {
      if (!updatedValue) {
        error = "Please select category";
      }
    }

    if (name === "paymentMode") {
      if (!updatedValue) {
        error = "Please select payment mode";
      }
    }

    if (name === "status") {
      if (!updatedValue) {
        error = "Please select status";
      }
    }

    if (name === "notes") {
      if (updatedValue.length > 150) {
        error = "Notes maximum 150 characters only";
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validate = (name, value) => {
    let error = "";

    if (name === "title") {
      if (!value.trim()) {
        error = "Please enter title";
      } else if (value.length < 3) {
        error = "Minimum 3 characters required";
      } else if (value.length > 50) {
        error = "Maximum 50 characters only";
      }
    }

    if (name === "amount") {
      if (!value) {
        error = "Please enter amount";
      } else {
        const numericValue = Number(value);

        if (numericValue < 1) {
          error = "Minimum amount is 1";
        }
      }
    }

    if (name === "taxAmount") {
      if (value) {
        const tax = Number(value);
        const amount = Number(formData.amount);

        if (tax < 0) {
          error = "Tax cannot be negative";
        } else if (amount && tax >= amount) {
          error = "Tax must be less than amount";
        }
      }
    }
    if (name === "expenseDate") {
      if (!value) {
        error = "Please select expense date";
      }
    }

    if (name === "category") {
      if (!value) {
        error = "Please select category";
      }
    }

    if (name === "paymentMode") {
      if (!value) {
        error = "Please select payment mode";
      }
    }

    if (name === "status") {
      if (!value) {
        error = "Please select status";
      }
    }

    if (name === "notes") {
      if (value.length > 150) {
        error = "Notes maximum 150 characters only";
      }
    }

    return error;
  };

  // handle submit --- >
  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    Object.keys(formData).forEach((key) => {
      const error = validate(key, formData[key]);
      if (error) {
        newErrors[key] = error;
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length !== 0) {
      return;
    }

    setLoading(true);

    const payload = {
      title: formData.title.trim(),
      category: formData.category,
      amount: Number(formData.amount),
      taxAmount: Number(formData.taxAmount || 0),
      expenseDate: formData.expenseDate,
      paymentMode: formData.paymentMode,
      notes: formData.notes?.trim(),
      status: formData.status,
    };

    try {
      await dispatch(addExpense(payload)).unwrap();
      toast.success("Expense add successfully");
      navigate("/hotel/expense");
      setFormData(expensestate);
    } catch (error) {
      toast.error(error || "Failed  to add expense");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-3">
        <div className="breadcrumb-left">
          <Link to="/hotel/home" className="breadcrumb-link active">
            Home
          </Link>
          |
          <Link to="/hotel/expense" className="breadcrumb-link active">
            Expense
          </Link>
          | <span className="breadcrumb-link inactive">Add Expense</span>
        </div>
      </div>

      <Container>
        <div className="container mt-4">
          <Card style={{ border: "none" }}>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        type="text"
                        name="title"
                        placeholder="Enter expense title"
                        value={formData.title}
                        onChange={handleChange}
                        minLength={3}
                        maxLength={100}
                      />
                      {errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Category</Form.Label>
                      <Form.Select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                      >
                        <option value="">Select category</option>
                        <option value="hotel">Hotel</option>
                        <option value="vehicle">Vehicle</option>
                        <option value="ferry">Ferry</option>
                        <option value="commission">Commission</option>
                        <option value="salary">Salary</option>
                        <option value="office">Office</option>
                        <option value="marketing">Marketing</option>
                        <option value="refund">Refund</option>
                        <option value="miscellaneous">Miscellaneous</option>
                      </Form.Select>
                      {errors.category && (
                        <small className="text-danger">{errors.category}</small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        type="text"
                        name="amount"
                        placeholder="Enter amount"
                        value={formData.amount}
                        onChange={handleChange}
                        maxLength={7}
                        minLength={2}
                      />
                      {errors.amount && (
                        <small className="text-danger">{errors.amount}</small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Tax Amount</Form.Label>
                      <Form.Control
                        type="text"
                        name="taxAmount"
                        placeholder="Enter tax amount"
                        value={formData.taxAmount}
                        onChange={handleChange}
                      />
                      {errors.taxAmount && (
                        <small className="text-danger">
                          {errors.taxAmount}
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="expenseDate"
                        value={formData.expenseDate}
                        onChange={handleChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                      {errors.expenseDate && (
                        <small className="text-danger">
                          {errors.expenseDate}
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Payment Mode</Form.Label>
                      <Form.Select
                        name="paymentMode"
                        value={formData.paymentMode}
                        onChange={handleChange}
                      >
                        <option value="">Select payment mode</option>
                        <option value="cash">Cash</option>
                        <option value="bank">Bank</option>
                        <option value="upi">UPI</option>
                        <option value="card">Card</option>
                        <option value="cheque">Cheque</option>
                      </Form.Select>
                      {errors.paymentMode && (
                        <small className="text-danger">
                          {errors.paymentMode}
                        </small>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                      >
                        <option value="">Select status</option>
                        <option value="paid">Paid</option>
                        <option value="pending">Pending</option>
                      </Form.Select>
                      {errors.status && (
                        <small className="text-danger">{errors.status}</small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Notes (Optional)</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        name="notes"
                        placeholder="Enter notes"
                        value={formData.notes}
                        onChange={handleChange}
                        maxLength={250}
                      />
                      {errors.notes && (
                        <small className="text-danger">{errors.notes}</small>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Buttons */}
                <div className="text-center mt-5 mb-5">
                  <button
                    type="button"
                    className="cancel-btn me-3"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="light"
                          className="me-2"
                        />
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </>
  );
}
